<template>
    <label class="field-label" v-bind="$attrs">
        <slot></slot>
    </label>
</template>

<script>
    export default {
        name: 'SubTitle',
        props: {
            for: String,
        }
    }
</script>

<style scoped>
.field-label {
    margin-bottom: 3px;
}
</style>